module.exports = __webpack_public_path__ + "b33d3ee2bbe2653e50e7a0c6149e5bf1.png";